import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loading } from '../ui/Loading';
import { toast } from 'react-hot-toast';
import { useEffect } from 'react';
import { supabase } from '@wammasys/supabase';

export function ProtectedRoute() {
  const { user, loading, signOut } = useAuth();

  // Check if email is verified for logged-in users
  useEffect(() => {
    const verifyEmail = async () => {
      if (user && !user.email_confirmed_at) {
        toast.error('Please verify your email before accessing this page.');
        await signOut();
      }
    };

    verifyEmail();
  }, [user, signOut]);

  // Show loading indicator while checking authentication
  if (loading) {
    return <Loading />;
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  // Additional check for email verification
  if (user && !user.email_confirmed_at) {
    // Clean up any session data that might remain
    supabase.auth.signOut();
    return <Navigate to="/auth/login" replace />;
  }

  // Render the protected content
  return <Outlet />;
} 
